export default {
  BusinessPurchaseApply: {
    header: {
      code: '采购申请单号',
      supplier: '要求供应商',
      warehouseCode: '要求收货仓库',
      arrivalTime: '要求到货时间',
      startData: '开始日期',
      endData: '结束日期',
      status: '订单状态',
      spuCode: '商品编码',
      skuCode: 'SKU编码',
      applicant: '申请人'
    },

    review: '审核',
    antiAudit: '反审核',
    closeApplication: '关闭申请',
    purchaseOrder: '转采购单',
    export: '导出',
    warning1: '存在状态不正确的单据，无法执行当前操作',
    msgError: '申请单已生成采购单，无法执行当前操作',
    warning2: '是否关闭所选单据采购申请，关闭后该申请单无法继续生成采购单',
    warning3: '是否',
    warning4: '所选单据',
    applicationExport: '采购申请单导出',
    Reduction: '降本统计表',
    status: '采购申请单状态',
    isFill: '采购信息完备',
    copyPurchaseOrder: '复制采购单',
    cancelledPurchase: '废弃采购申请单',
    cancelReason: '废弃原因',
    tableIsFill: '是否完成必要信息填写',
    confirmMessage: '是否确认复制采购单?',
    planQty: '预测采购数',
    cnPurchasePrice: '人民币采购价',
    foreignPurchasePrice: '外币采购价',
    price: '预计Ebay售价',
    usdFreight: '美金运费',
    cnyFreight: '人民币运费',
    handlePrice: '处理费',
    cabinetVolume: '柜子体积',
    seaInlandFreight: '海运与内陆运费',
    ebayPaypalPrice: 'Ebay+paypal费用',

    table: {
      code: '采购申请单号',
      warehouseCode: '要求收货仓库',
      arrivalTime: '要求到货时间',
      status: '订单状态',
      auditDate: '审核时间',
      planQty: '申请数量',
      alreadyQty: '已下采购数量',
      waitQty: '未下采购数量',
      remark: '备注',
      auditName: '审核人',
      dailySales: '日销售数量'
    },

    dataForm: {
      title: '采购申请单基本信息',
      code: '采购申请单号',
      automatic: '自动生成',
      warehouseCode: '要求收货仓库',
      arrivalTime: '要求到货时间',
      remark: '备注',
      information: '商品信息',
      addingGoods: '添加商品',
      picture: '商品图片',
      supplierCode: '要求供应商',
      // spuCode: '商品编码',
      // spuName: '商品名称',
      skuCode: 'SKU编码',
      skuName: 'SKU名称',
      planQty: '申请数量',
      warehouseCodeText: '请选择收货仓库',
      arrivalTimeText: '请选择到货时间',
      planQtyText: '输入申请数量',
      dialogText: '选择供应商商品',
      new: '新建',
      purchase: '采购申请单',
      msgError: '请选择商品',
      orderQuantity: '未下采购单数量',
      quantity: '下单数量',
      lastPrice: '含税下单价',
      taxRate: '税率',
      tax: '含税金额',
      commodityCode: '供应商商品编码',
      commoditySku: '供应商SKU编码',
      commodityRemark: '商品备注',
    }
  }
};
